import React from 'react';

const CSS = require('./MenuLabel.module.scss');

interface MenuLabelProps {
  children: string;
}

function MenuLabel({ children }: MenuLabelProps) {
  return <div className={CSS.MenuLabel}>{children}</div>;
}

export default MenuLabel;
